module.exports = __webpack_public_path__ + "static/media/naman-retreat.22d40c04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sites/naman-retreat.png
// module id = 328
// module chunks = 0